import * as lib from '$lib/lib.js';
import { filterLocations } from '$lib/locations.js';
import * as log from '$lib/log.js';

class AppState {
  subscriptions = $state([]);
  log = $state([]);
  // The polygon currently drawn or selected on the map. Consumed by
  // lib.subscribe() to build a subscription. Not persisted to localStorage.
  region = $state({ modified: false, geojson: {} });

  // Hydrate the state from the page load data. Stored subscriptions are
  // validated; on failure everything is dropped and will be refetched.
  init(data) {
    this.region = { modified: false, geojson: {} };

    const valid = data.subscriptions.every((s) => {
      const check = lib.validateSubscription(s);
      if (!check.valid) {
        console.log(check.error);
      }
      return check.valid;
    });

    if (!valid) {
      console.log("Stored subscriptions aren't valid");
      this.subscriptions = [];
      this.log = [];
      return;
    }

    this.subscriptions = data.subscriptions;
    this.log = data.log;

    // Journal events created by an older frontend can reference location ids
    // which do not exist anymore (locations were re-keyed to RÚIAN ids).
    // Syncing them would be rejected by the backend, so they are cancelled
    // before the first sync. Synced subscriptions are replaced by the
    // backend state on the next sync anyway.
    log.drop_stale_adds(
      this,
      (id) =>
        id === 0 ||
        id === lib.CUSTOM_REGION_VALUE ||
        filterLocations.all[id] !== undefined
    );
  }
}

export const appState = new AppState();
